<template>
  <div id="app" class="u-full-vp-width u-full-vp-height u-relative u-overflow-hidden">
    <SymbolsSvg />
    <div ref="containerWebGL" class="u-wrapper-panel"/>
    <transition name="t-fader">
      <router-view class="u-wrapper-panel" />
    </transition>
    <div ref="containerCSS3D" class="u-wrapper-panel u-overflow-hidden u-pointer-none"/>
  </div>
</template>

<script>
import App from './App'

import SymbolsSvg from '@/components/SymbolsSvg'

import {
  AmbientLight,
  SphereBufferGeometry,
  MeshNormalMaterial,
  Mesh
} from 'three'

export default {
  name: 'App',

  mixins: [App],

  components: {
    SymbolsSvg
  }
}
</script>

<style lang="stylus" src="./styles/theme.styl"/>

<!-- <style lang="stylus">
@import '~@/styles/settings/variables'
</style> -->
